import { useStore } from "vuex";
import useEntryRedirect from "@/views/person/useEntryRedirect.js";
import useCategoryRedirect from "@/views/category/useCategoryRedirect.js";
import useCategoriesRedirect from "@/views/categories/useCategoriesRedirect.js";

export default function useRedirect() {
  const store = useStore();
  const { categoriesRedirect } = useCategoriesRedirect();
  const { categoryRedirect } = useCategoryRedirect();
  const { entryRedirect } = useEntryRedirect();

  /*
   * support legacy urls from when the site ran in hash mode
   */
  function redirectHashUrls(to) {
    const urlSplit = to.fullPath.split("?");
    if (urlSplit.length > 1) {
      const queryParams = Object.fromEntries(
        new URLSearchParams(urlSplit[1]).entries()
      );
      return { path: to.hash.substring(1), query: queryParams };
    }
    return { path: to.hash.substring(1) };
  }

  /*
  Check for redirects before data is loaded
   */
  function preDataRedirect(to) {
    if (to.name === "PostRedirect") {
      return undefined;
    }

    const siteId = store.getters.getStyleID;

    if (!siteId) {
      return { name: "NotFound404" };
    }

    if (siteId && to.params.styleid === "lookup") {
      return { name: "Home", params: { styleid: siteId } };
    }

    // Check if the siteID is different to the route style ID.
    // This is to ensure custom domains match the correct site.
    if (siteId !== to.params.styleid) {
      return { name: "Home", params: { styleid: siteId } };
    }
    // if attempting to enter a cmsOnly route and not logged in then redirect the user to login
    if ((to.meta.adminOnly || to.meta.cmsOnly) && !store.getters.isAuth) {
      return {
        name: "Login",
        params: { styleid: to.params.styleid },
      };
    }
    // if attempting to enter an admin route and not a site admin, redirect to home
    if (to.meta.adminOnly && !store.getters.getIsAdmin) {
      return {
        name: "Home",
        params: {
          styleid: to.params.styleid,
          query: { redirect: to.fullPath },
        },
      };
    }
    return undefined;
  }

  /*
  Check for any redirects that require site data to be loaded
   */
  function postDataRedirect(to) {
    if (to.name.includes("Categories") || to.name.includes("SubCategories")) {
      return categoriesRedirect(to);
    }
    if (to.name === "Category") {
      return categoryRedirect(to);
    }
    if (to.name === "Person") {
      return entryRedirect(to);
    }
    return undefined;
  }

  return { preDataRedirect, postDataRedirect, redirectHashUrls };
}
